<script>
    export default {
        data() {
            return {
                faStarFull: 'fa-solid fa-star',
                faStarHalf: 'fa-solid fa-star-half-stroke',
                faStarEmpty: 'fa-regular fa-star',
            }
        },
        props: {
            rating: {
                type: Number,
                required: true,
                validator: value => value >= 0 && value <= 10
            }
        },
        computed: {
            starsArray() {
                const starRating = this.rating / 2;
                const fullStars = Math.floor(starRating);
                const hasHalfStar = starRating - fullStars >= 0.5;
                const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

                const starsArray = [
                    ...Array(fullStars).fill(this.faStarFull),
                    ...(hasHalfStar ? [this.faStarHalf] : []),
                    ...Array(emptyStars).fill(this.faStarEmpty)
                ];

                return starsArray;
            }
        }
    };
</script>

<template>
    <div class="has-text-primary is-flex-shrink-0">
        <i v-for="(star, index) in starsArray" :key="`star-${index}`" :class="star"></i>
    </div>
</template>